module.exports = __webpack_public_path__ + "static/media/imgupload.ca29183b.png";